export enum AnswerState {
  // eslint-disable-next-line no-unused-vars
  NOT_SUBMITTED = "NOT_SUBMITTED",
  // eslint-disable-next-line no-unused-vars
  CORRECT = "CORRECT",
  // eslint-disable-next-line no-unused-vars
  INCORRECT = "INCORRECT",
}

export interface AnswerProps {
  value: string;
  state: AnswerState;
}

export class Answer {
  readonly value: string;
  readonly state: AnswerState;

  constructor({ value, state }: AnswerProps) {
    this.value = value;
    this.state = state;
  }

  isSubmitted(): boolean {
    return this.state !== AnswerState.NOT_SUBMITTED;
  }

  isCorrect(): boolean {
    return this.state === AnswerState.CORRECT;
  }

  isIncorrect(): boolean {
    return this.state === AnswerState.INCORRECT;
  }
}
